import React from "react";
import Header from "../../sharedComponents/header/header";
import "./additionalInsurances.scss";
import { CalculateStore } from "../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import NonResidentialBuilding from "./nonResidentialBuilding/nonResidentialBuilding";
import OnlyInsuranceSum from "./onlyInsuranceSum/onlyInsuranceSum";
import CatAndDog from "./catAndDog/catAndDog";
import Gravestone from "./gravestone/gravestone";
import { RisksId } from "../../../helpers/risk";
import Oc from "./oc/oc";
import Nnw from "./nnw/nnw";
import LegalProtection from "./legalProtection/legalProtection";
import SafeSenior from "./safeSenior/safeSenior";
import SecondOpinion from "./secondOpinion/secondOpinion";

interface AdditionalInsurancesProps {
  calculateStore?: CalculateStore;
}

@inject("calculateStore")
@observer
export default class AdditionalInsurances extends React.Component<AdditionalInsurancesProps, any> {

  public render() {
    return (
      <div className="additional-insurances">
        <Header type="medium" mainHeader="Dodatkowy zakres ochrony" />
        <SecondOpinion />
        <NonResidentialBuilding />
        <OnlyInsuranceSum riskId={RisksId.fixedEstateElements} className="fixed-estate-elements" />
        <OnlyInsuranceSum riskId={RisksId.greenEnergySources} className="green-energy-sources" />
        <CatAndDog />
        <SafeSenior />
        <Oc />
        <LegalProtection />
        <Nnw />
        <Gravestone />
      </div>
    );
  }
}
